export enum LoadFilterTypeEnum {
    PROPPANT = 'Proppant',
    LOADING_FACILITY = 'Loading Facility',
    DRIVER = 'Driver',
    CARRIER = 'Carrier',
    STATUS = 'Status',
}
